import { defu } from 'defu'

export type ModifierKey = 'ctrl' | 'alt' | 'shift' | 'meta'
export type Hotkeys =
  | 'Enter'
  | 'Escape'
  | 'Space'
  | 'Tab'
  | 'ArrowUp'
  | 'ArrowDown'
  | 'ArrowLeft'
  | 'ArrowRight'
  | 'Delete'
  | (string & {})

export function isCorrectCombo(event: KeyboardEvent, key: string, modifier?: ModifierKey): boolean {
  // for some reason those can be undefined 🤔
  const pressedKey = event.key?.toLowerCase()
  const expectedKey = key.toLowerCase()

  // Prüfe Haupttaste
  if (pressedKey !== expectedKey) {
    return false
  }

  // Prüfe Modifier
  if (!modifier) {
    return !event.ctrlKey && !event.altKey && !event.shiftKey && !event.metaKey
  }

  const modifierPressed = {
    ctrl: event.ctrlKey,
    alt: event.altKey,
    shift: event.shiftKey,
    meta: event.metaKey,
  }

  const expectedModifier = modifier

  // Nur der erwartete Modifier sollte gedrückt sein
  return Object.entries(modifierPressed).every(([mod, pressed]) => (mod === expectedModifier ? pressed : !pressed))
}

type KeydownOptions = {
  modifier?: ModifierKey
  prevent?: boolean
  stop?: boolean
}

/**
 * Invokes callback if keydown event matches given key and modifier.
 */
export function handleHotkey(
  event: KeyboardEvent,
  key: string,
  callback: (ev: KeyboardEvent) => unknown,
  options?: KeydownOptions,
) {
  const _options = defu(options, { prevent: true, stop: false })

  if (isCorrectCombo(event, key, _options.modifier)) {
    if (_options.prevent) {
      event.preventDefault()
    }
    if (_options.stop) {
      event.stopPropagation()
    }
    callback(event)
  }
}
